export default "__VITE_ASSET__c3e1171b__"